<template>
    <!--
          描述：商品属性管理
      -->
    <div class="product">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                <div>
                    <el-form-item label="属性名称">
                        <el-input v-model="searchForm.unit_name" size="small" placeholder="请输入商品名称" @keyup.enter.native="onSubmit" />
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <!--添加商品属性-->
        <div class="common-level-rail">
            <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/unit/add'">
                添加属性
            </el-button>
        </div>

        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table
                        size="small"
                        :data="tableData"
                        style="width: 100%"
                        v-loading="loading">
                    <el-table-column prop="unit_name" label="属性名称" width="180"></el-table-column>
                    <el-table-column prop="sort" label="属性排序"></el-table-column>
                    <el-table-column prop="create_time" label="添加时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/unit/edit'">编辑</el-button>
                            <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/product/unit/delete'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!--分页-->
        <div class="pagination mg-top30">
            <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
            />
        </div>

        <!--添加-->
        <Add v-if="open_add" :open_add="open_add" :addform="unitModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
        <!--修改-->
        <Edit v-if="open_edit" :open_edit="open_edit" :editform="unitModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
    </div>
</template>

<script>
    import ProductApi from '@/api/product.js';
    import Add from './Add.vue';
    import Edit from './Edit.vue';

    export default {
        components: {
            Add,
            Edit
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                unitModel: {
                    nuitList: [],
                    model: {}
                },
                // 一页多少条
                pageSize: 20,
                // 一共多少条数据
                totalDataNumber: 0,
                // 当前是第几页
                curPage: 1,
                // 搜索参数
                searchForm: {
                    unit_name: '',
                },
            };
        },
        created() {
            /*获取列表*/
            this.getData();
        },
        methods: {
            // 获取列表
            getData() {
                let self = this;
                const Params = self.searchForm
                Params.page = self.curPage
                Params.list_rows = self.pageSize
                ProductApi.unitList(Params, true)
                    .then(data => {
                        self.loading = false;
                        self.unitModel.nuitList = data.data.list.data;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            // 选择第几页
            handleCurrentChange(val) {
                const self = this
                self.loading = true
                self.curPage = val
                self.getData()
            },

            // 每页多少条
            handleSizeChange(val) {
                this.pageSize = val
                this.getData()
            },

            /** 搜索查询 **/
            onSubmit() {
                this.curPage = 1
                this.getData()
            },

            // 打开添加
            addClick() {
                this.open_add = true;
            },

            // 打开编辑
            editClick(item) {
                this.unitModel.model = item;
                this.open_edit = true;
            },

            // 关闭弹窗
            closeDialogFunc(e, f) {
                if (f == 'add') {
                    this.open_add = e.openDialog;
                    if (e.type == 'success') {
                        this.getData();
                    }
                }
                if (f == 'edit') {
                    this.open_edit = e.openDialog;
                    if (e.type == 'success') {
                        this.getData();
                    }
                }
            },

            // 删除属性
            deleteClick(row) {
                let self = this;
                self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    ProductApi.unitDel({
                        unit_id: row.unit_id
                    }).then(data => {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        self.getData();
                    });
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/product/attribute/index.vue